export const taxCertificateFields = {
  id: {
    fieldPath: 'id',
    fieldReadPath: 'id',
    name: 'id',
  },
  center_id: {
    fieldPath: 'center_id',
    fieldReadPath: 'center_id',
    name: 'center_id',
  },
  tax_certificate_periods: {
    fieldPath: 'tax_certificate_periods',
    fieldReadPath: 'tax_certificate_periods',
    name: 'tax_certificate_periods',
  },
  code: {
    fieldPath: 'code',
    fieldReadPath: 'code',
    name: 'code',
    label: 'global.tax_certificates_code_label',
    inputType: 'input',
    options: [],
    id: 'tax_certificate__code',
    veeValidation: true,
    rules: ['nullable', 'string', 'without_spaces'],
    warningRules: [],
    tags: [],
  },
  beneficiary_firstname: {
    fieldPath: 'beneficiary_firstname',
    fieldReadPath: 'beneficiary_firstname',
    name: 'beneficiary_firstname',
    label: 'global.tax_certificates_beneficiary_firstname_label',
    inputType: 'input',
    options: [],
    id: 'tax_certificate__beneficiary_firstname',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    tags: [],
  },
  beneficiary_lastname: {
    fieldPath: 'beneficiary_lastname',
    fieldReadPath: 'beneficiary_lastname',
    name: 'beneficiary_lastname',
    label: 'global.tax_certificates_beneficiary_lastname_label',
    inputType: 'input',
    options: [],
    id: 'tax_certificate__beneficiary_lastname',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    tags: [],
  },
  beneficiary_national_number: {
    fieldPath: 'beneficiary_national_number',
    fieldReadPath: 'beneficiary_national_number',
    name: 'beneficiary_national_number',
    label: 'global.tax_certificates_beneficiary_national_number_label',
    inputType: 'input',
    options: [],
    id: 'tax_certificate__beneficiary_national_number',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    tags: [],
  },
  beneficiary_birthdate: {
    fieldPath: 'beneficiary_birthdate',
    fieldReadPath: 'beneficiary_birthdate',
    name: 'beneficiary_birthdate',
    label: 'global.tax_certificates_beneficiary_birthdate_label',
    inputType: 'datepicker',
    options: [],
    id: 'tax_certificate__beneficiary_birthdate',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    tags: [],
  },
  beneficiary_street: {
    fieldPath: 'beneficiary_street',
    fieldReadPath: 'beneficiary_street',
    name: 'beneficiary_street',
    label: 'global.tax_certificates_beneficiary_street_label',
    inputType: 'input',
    options: [],
    id: 'tax_certificate__beneficiary_street',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    tags: [],
  },
  beneficiary_street2: {
    fieldPath: 'beneficiary_street2',
    fieldReadPath: 'beneficiary_street2',
    name: 'beneficiary_street2',
    label: 'global.tax_certificates_beneficiary_street2_label',
    inputType: 'input',
    options: [],
    id: 'tax_certificate__beneficiary_street2',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    tags: [],
  },
  beneficiary_zip: {
    fieldPath: 'beneficiary_zip',
    fieldReadPath: 'beneficiary_zip',
    name: 'beneficiary_zip',
    label: 'global.tax_certificates_beneficiary_zip_label',
    inputType: 'input',
    options: [],
    id: 'tax_certificate__beneficiary_zip',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    tags: [],
  },
  beneficiary_city: {
    fieldPath: 'beneficiary_city',
    fieldReadPath: 'beneficiary_city',
    name: 'beneficiary_city',
    label: 'global.tax_certificates_beneficiary_city_label',
    inputType: 'input',
    options: [],
    id: 'tax_certificate__beneficiary_city',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    tags: [],
  },
  beneficiary_country: {
    fieldPath: 'beneficiary_country',
    fieldReadPath: 'beneficiary_country',
    name: 'beneficiary_country',
    label: 'global.tax_certificates_beneficiary_country_label',
    inputType: 'countries-selector',
    options: [
      {
        text: 'countries.placeholder',
        value: 'null',
      },
      {
        text: 'countries.ad',
        value: 'ad',
      },
      {
        text: 'countries.ae',
        value: 'ae',
      },
      {
        text: 'countries.af',
        value: 'af',
      },
      {
        text: 'countries.ag',
        value: 'ag',
      },
      {
        text: 'countries.ai',
        value: 'ai',
      },
      {
        text: 'countries.al',
        value: 'al',
      },
      {
        text: 'countries.am',
        value: 'am',
      },
      {
        text: 'countries.ao',
        value: 'ao',
      },
      {
        text: 'countries.aq',
        value: 'aq',
      },
      {
        text: 'countries.ar',
        value: 'ar',
      },
      {
        text: 'countries.as',
        value: 'as',
      },
      {
        text: 'countries.at',
        value: 'at',
      },
      {
        text: 'countries.au',
        value: 'au',
      },
      {
        text: 'countries.aw',
        value: 'aw',
      },
      {
        text: 'countries.ax',
        value: 'ax',
      },
      {
        text: 'countries.az',
        value: 'az',
      },
      {
        text: 'countries.ba',
        value: 'ba',
      },
      {
        text: 'countries.bb',
        value: 'bb',
      },
      {
        text: 'countries.bd',
        value: 'bd',
      },
      {
        text: 'countries.be',
        value: 'be',
      },
      {
        text: 'countries.bf',
        value: 'bf',
      },
      {
        text: 'countries.bg',
        value: 'bg',
      },
      {
        text: 'countries.bh',
        value: 'bh',
      },
      {
        text: 'countries.bi',
        value: 'bi',
      },
      {
        text: 'countries.bj',
        value: 'bj',
      },
      {
        text: 'countries.bl',
        value: 'bl',
      },
      {
        text: 'countries.bm',
        value: 'bm',
      },
      {
        text: 'countries.bn',
        value: 'bn',
      },
      {
        text: 'countries.bo',
        value: 'bo',
      },
      {
        text: 'countries.bq',
        value: 'bq',
      },
      {
        text: 'countries.br',
        value: 'br',
      },
      {
        text: 'countries.bs',
        value: 'bs',
      },
      {
        text: 'countries.bt',
        value: 'bt',
      },
      {
        text: 'countries.bv',
        value: 'bv',
      },
      {
        text: 'countries.bw',
        value: 'bw',
      },
      {
        text: 'countries.by',
        value: 'by',
      },
      {
        text: 'countries.bz',
        value: 'bz',
      },
      {
        text: 'countries.ca',
        value: 'ca',
      },
      {
        text: 'countries.cc',
        value: 'cc',
      },
      {
        text: 'countries.cd',
        value: 'cd',
      },
      {
        text: 'countries.cf',
        value: 'cf',
      },
      {
        text: 'countries.cg',
        value: 'cg',
      },
      {
        text: 'countries.ch',
        value: 'ch',
      },
      {
        text: 'countries.ci',
        value: 'ci',
      },
      {
        text: 'countries.ck',
        value: 'ck',
      },
      {
        text: 'countries.cl',
        value: 'cl',
      },
      {
        text: 'countries.cm',
        value: 'cm',
      },
      {
        text: 'countries.cn',
        value: 'cn',
      },
      {
        text: 'countries.co',
        value: 'co',
      },
      {
        text: 'countries.cr',
        value: 'cr',
      },
      {
        text: 'countries.cu',
        value: 'cu',
      },
      {
        text: 'countries.cv',
        value: 'cv',
      },
      {
        text: 'countries.cw',
        value: 'cw',
      },
      {
        text: 'countries.cx',
        value: 'cx',
      },
      {
        text: 'countries.cy',
        value: 'cy',
      },
      {
        text: 'countries.cz',
        value: 'cz',
      },
      {
        text: 'countries.de',
        value: 'de',
      },
      {
        text: 'countries.dj',
        value: 'dj',
      },
      {
        text: 'countries.dk',
        value: 'dk',
      },
      {
        text: 'countries.dm',
        value: 'dm',
      },
      {
        text: 'countries.do',
        value: 'do',
      },
      {
        text: 'countries.dz',
        value: 'dz',
      },
      {
        text: 'countries.ec',
        value: 'ec',
      },
      {
        text: 'countries.ee',
        value: 'ee',
      },
      {
        text: 'countries.eg',
        value: 'eg',
      },
      {
        text: 'countries.eh',
        value: 'eh',
      },
      {
        text: 'countries.er',
        value: 'er',
      },
      {
        text: 'countries.es',
        value: 'es',
      },
      {
        text: 'countries.et',
        value: 'et',
      },
      {
        text: 'countries.fi',
        value: 'fi',
      },
      {
        text: 'countries.fj',
        value: 'fj',
      },
      {
        text: 'countries.fk',
        value: 'fk',
      },
      {
        text: 'countries.fm',
        value: 'fm',
      },
      {
        text: 'countries.fo',
        value: 'fo',
      },
      {
        text: 'countries.fr',
        value: 'fr',
      },
      {
        text: 'countries.ga',
        value: 'ga',
      },
      {
        text: 'countries.gb',
        value: 'gb',
      },
      {
        text: 'countries.gd',
        value: 'gd',
      },
      {
        text: 'countries.ge',
        value: 'ge',
      },
      {
        text: 'countries.gf',
        value: 'gf',
      },
      {
        text: 'countries.gg',
        value: 'gg',
      },
      {
        text: 'countries.gh',
        value: 'gh',
      },
      {
        text: 'countries.gi',
        value: 'gi',
      },
      {
        text: 'countries.gl',
        value: 'gl',
      },
      {
        text: 'countries.gm',
        value: 'gm',
      },
      {
        text: 'countries.gn',
        value: 'gn',
      },
      {
        text: 'countries.gp',
        value: 'gp',
      },
      {
        text: 'countries.gq',
        value: 'gq',
      },
      {
        text: 'countries.gr',
        value: 'gr',
      },
      {
        text: 'countries.gs',
        value: 'gs',
      },
      {
        text: 'countries.gt',
        value: 'gt',
      },
      {
        text: 'countries.gu',
        value: 'gu',
      },
      {
        text: 'countries.gw',
        value: 'gw',
      },
      {
        text: 'countries.gy',
        value: 'gy',
      },
      {
        text: 'countries.hk',
        value: 'hk',
      },
      {
        text: 'countries.hm',
        value: 'hm',
      },
      {
        text: 'countries.hn',
        value: 'hn',
      },
      {
        text: 'countries.hr',
        value: 'hr',
      },
      {
        text: 'countries.ht',
        value: 'ht',
      },
      {
        text: 'countries.hu',
        value: 'hu',
      },
      {
        text: 'countries.id',
        value: 'id',
      },
      {
        text: 'countries.ie',
        value: 'ie',
      },
      {
        text: 'countries.il',
        value: 'il',
      },
      {
        text: 'countries.im',
        value: 'im',
      },
      {
        text: 'countries.in',
        value: 'in',
      },
      {
        text: 'countries.io',
        value: 'io',
      },
      {
        text: 'countries.iq',
        value: 'iq',
      },
      {
        text: 'countries.ir',
        value: 'ir',
      },
      {
        text: 'countries.is',
        value: 'is',
      },
      {
        text: 'countries.it',
        value: 'it',
      },
      {
        text: 'countries.je',
        value: 'je',
      },
      {
        text: 'countries.jm',
        value: 'jm',
      },
      {
        text: 'countries.jo',
        value: 'jo',
      },
      {
        text: 'countries.jp',
        value: 'jp',
      },
      {
        text: 'countries.ke',
        value: 'ke',
      },
      {
        text: 'countries.kg',
        value: 'kg',
      },
      {
        text: 'countries.kh',
        value: 'kh',
      },
      {
        text: 'countries.ki',
        value: 'ki',
      },
      {
        text: 'countries.km',
        value: 'km',
      },
      {
        text: 'countries.kn',
        value: 'kn',
      },
      {
        text: 'countries.kp',
        value: 'kp',
      },
      {
        text: 'countries.kr',
        value: 'kr',
      },
      {
        text: 'countries.kw',
        value: 'kw',
      },
      {
        text: 'countries.ky',
        value: 'ky',
      },
      {
        text: 'countries.kz',
        value: 'kz',
      },
      {
        text: 'countries.la',
        value: 'la',
      },
      {
        text: 'countries.lb',
        value: 'lb',
      },
      {
        text: 'countries.lc',
        value: 'lc',
      },
      {
        text: 'countries.li',
        value: 'li',
      },
      {
        text: 'countries.lk',
        value: 'lk',
      },
      {
        text: 'countries.lr',
        value: 'lr',
      },
      {
        text: 'countries.ls',
        value: 'ls',
      },
      {
        text: 'countries.lt',
        value: 'lt',
      },
      {
        text: 'countries.lu',
        value: 'lu',
      },
      {
        text: 'countries.lv',
        value: 'lv',
      },
      {
        text: 'countries.ly',
        value: 'ly',
      },
      {
        text: 'countries.ma',
        value: 'ma',
      },
      {
        text: 'countries.mc',
        value: 'mc',
      },
      {
        text: 'countries.md',
        value: 'md',
      },
      {
        text: 'countries.me',
        value: 'me',
      },
      {
        text: 'countries.mf',
        value: 'mf',
      },
      {
        text: 'countries.mg',
        value: 'mg',
      },
      {
        text: 'countries.mh',
        value: 'mh',
      },
      {
        text: 'countries.mk',
        value: 'mk',
      },
      {
        text: 'countries.ml',
        value: 'ml',
      },
      {
        text: 'countries.mm',
        value: 'mm',
      },
      {
        text: 'countries.mn',
        value: 'mn',
      },
      {
        text: 'countries.mo',
        value: 'mo',
      },
      {
        text: 'countries.mp',
        value: 'mp',
      },
      {
        text: 'countries.mq',
        value: 'mq',
      },
      {
        text: 'countries.mr',
        value: 'mr',
      },
      {
        text: 'countries.ms',
        value: 'ms',
      },
      {
        text: 'countries.mt',
        value: 'mt',
      },
      {
        text: 'countries.mu',
        value: 'mu',
      },
      {
        text: 'countries.mv',
        value: 'mv',
      },
      {
        text: 'countries.mw',
        value: 'mw',
      },
      {
        text: 'countries.mx',
        value: 'mx',
      },
      {
        text: 'countries.my',
        value: 'my',
      },
      {
        text: 'countries.mz',
        value: 'mz',
      },
      {
        text: 'countries.na',
        value: 'na',
      },
      {
        text: 'countries.nc',
        value: 'nc',
      },
      {
        text: 'countries.ne',
        value: 'ne',
      },
      {
        text: 'countries.nf',
        value: 'nf',
      },
      {
        text: 'countries.ng',
        value: 'ng',
      },
      {
        text: 'countries.ni',
        value: 'ni',
      },
      {
        text: 'countries.nl',
        value: 'nl',
      },
      {
        text: 'countries.no',
        value: 'no',
      },
      {
        text: 'countries.np',
        value: 'np',
      },
      {
        text: 'countries.nr',
        value: 'nr',
      },
      {
        text: 'countries.nu',
        value: 'nu',
      },
      {
        text: 'countries.nz',
        value: 'nz',
      },
      {
        text: 'countries.om',
        value: 'om',
      },
      {
        text: 'countries.pa',
        value: 'pa',
      },
      {
        text: 'countries.pe',
        value: 'pe',
      },
      {
        text: 'countries.pf',
        value: 'pf',
      },
      {
        text: 'countries.pg',
        value: 'pg',
      },
      {
        text: 'countries.ph',
        value: 'ph',
      },
      {
        text: 'countries.pk',
        value: 'pk',
      },
      {
        text: 'countries.pl',
        value: 'pl',
      },
      {
        text: 'countries.pm',
        value: 'pm',
      },
      {
        text: 'countries.pn',
        value: 'pn',
      },
      {
        text: 'countries.pr',
        value: 'pr',
      },
      {
        text: 'countries.ps',
        value: 'ps',
      },
      {
        text: 'countries.pt',
        value: 'pt',
      },
      {
        text: 'countries.pw',
        value: 'pw',
      },
      {
        text: 'countries.py',
        value: 'py',
      },
      {
        text: 'countries.qa',
        value: 'qa',
      },
      {
        text: 'countries.re',
        value: 're',
      },
      {
        text: 'countries.ro',
        value: 'ro',
      },
      {
        text: 'countries.rs',
        value: 'rs',
      },
      {
        text: 'countries.ru',
        value: 'ru',
      },
      {
        text: 'countries.rw',
        value: 'rw',
      },
      {
        text: 'countries.sa',
        value: 'sa',
      },
      {
        text: 'countries.sb',
        value: 'sb',
      },
      {
        text: 'countries.sc',
        value: 'sc',
      },
      {
        text: 'countries.sd',
        value: 'sd',
      },
      {
        text: 'countries.se',
        value: 'se',
      },
      {
        text: 'countries.sg',
        value: 'sg',
      },
      {
        text: 'countries.sh',
        value: 'sh',
      },
      {
        text: 'countries.si',
        value: 'si',
      },
      {
        text: 'countries.sj',
        value: 'sj',
      },
      {
        text: 'countries.sk',
        value: 'sk',
      },
      {
        text: 'countries.sl',
        value: 'sl',
      },
      {
        text: 'countries.sm',
        value: 'sm',
      },
      {
        text: 'countries.sn',
        value: 'sn',
      },
      {
        text: 'countries.so',
        value: 'so',
      },
      {
        text: 'countries.sr',
        value: 'sr',
      },
      {
        text: 'countries.ss',
        value: 'ss',
      },
      {
        text: 'countries.st',
        value: 'st',
      },
      {
        text: 'countries.sv',
        value: 'sv',
      },
      {
        text: 'countries.sx',
        value: 'sx',
      },
      {
        text: 'countries.sy',
        value: 'sy',
      },
      {
        text: 'countries.sz',
        value: 'sz',
      },
      {
        text: 'countries.tc',
        value: 'tc',
      },
      {
        text: 'countries.td',
        value: 'td',
      },
      {
        text: 'countries.tf',
        value: 'tf',
      },
      {
        text: 'countries.tg',
        value: 'tg',
      },
      {
        text: 'countries.th',
        value: 'th',
      },
      {
        text: 'countries.tj',
        value: 'tj',
      },
      {
        text: 'countries.tk',
        value: 'tk',
      },
      {
        text: 'countries.tl',
        value: 'tl',
      },
      {
        text: 'countries.tm',
        value: 'tm',
      },
      {
        text: 'countries.tn',
        value: 'tn',
      },
      {
        text: 'countries.to',
        value: 'to',
      },
      {
        text: 'countries.tr',
        value: 'tr',
      },
      {
        text: 'countries.tt',
        value: 'tt',
      },
      {
        text: 'countries.tv',
        value: 'tv',
      },
      {
        text: 'countries.tw',
        value: 'tw',
      },
      {
        text: 'countries.tz',
        value: 'tz',
      },
      {
        text: 'countries.ua',
        value: 'ua',
      },
      {
        text: 'countries.ug',
        value: 'ug',
      },
      {
        text: 'countries.um',
        value: 'um',
      },
      {
        text: 'countries.us',
        value: 'us',
      },
      {
        text: 'countries.uy',
        value: 'uy',
      },
      {
        text: 'countries.uz',
        value: 'uz',
      },
      {
        text: 'countries.va',
        value: 'va',
      },
      {
        text: 'countries.vc',
        value: 'vc',
      },
      {
        text: 'countries.ve',
        value: 've',
      },
      {
        text: 'countries.vg',
        value: 'vg',
      },
      {
        text: 'countries.vi',
        value: 'vi',
      },
      {
        text: 'countries.vn',
        value: 'vn',
      },
      {
        text: 'countries.vu',
        value: 'vu',
      },
      {
        text: 'countries.wf',
        value: 'wf',
      },
      {
        text: 'countries.ws',
        value: 'ws',
      },
      {
        text: 'countries.xk',
        value: 'xk',
      },
      {
        text: 'countries.ye',
        value: 'ye',
      },
      {
        text: 'countries.yt',
        value: 'yt',
      },
      {
        text: 'countries.za',
        value: 'za',
      },
      {
        text: 'countries.zm',
        value: 'zm',
      },
      {
        text: 'countries.zw',
        value: 'zw',
      },
      {
        text: 'countries.other',
        value: 'other',
      },
    ],
    id: 'tax_certificate__beneficiary_country',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    tags: [],
  },
  contact_id: {
    fieldPath: 'contact_id',
    fieldReadPath: 'contact_id',
    name: 'contact_id',
    label: 'global.tax_certificates_contact_id_label',
    inputType: 'input',
    options: [],
    id: 'tax_certificate__contact_id',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    tags: [],
    selectLabel: 'code_fullname',
    selectValue: 'id',
    selectEntity: 'contact',
    selectMultiple: false,
    withTableSearch: false,
    withNew: false,
    filters: [
      {
        filterField: 'type',
        modelField: null,
        value: ['individual'],
      },
      {
        filterField: 'status',
        modelField: null,
        value: ['active'],
      },
    ],
  },
  contact_firstname: {
    fieldPath: 'contact_firstname',
    fieldReadPath: 'contact_firstname',
    name: 'contact_firstname',
    label: 'global.tax_certificates_contact_firstname_label',
    inputType: 'input',
    options: [],
    id: 'tax_certificate__contact_firstname',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    tags: [],
  },
  contact_lastname: {
    fieldPath: 'contact_lastname',
    fieldReadPath: 'contact_lastname',
    name: 'contact_lastname',
    label: 'global.tax_certificates_contact_lastname_label',
    inputType: 'input',
    options: [],
    id: 'tax_certificate__contact_lastname',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    tags: [],
  },
  contact_national_number: {
    fieldPath: 'contact_national_number',
    fieldReadPath: 'contact_national_number',
    name: 'contact_national_number',
    label: 'global.tax_certificates_contact_national_number_label',
    inputType: 'input',
    options: [],
    id: 'tax_certificate__contact_national_number',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    tags: [],
  },
  contact_birthdate: {
    fieldPath: 'contact_birthdate',
    fieldReadPath: 'contact_birthdate',
    name: 'contact_birthdate',
    label: 'global.tax_certificates_contact_birthdate_label',
    inputType: 'datepicker',
    options: [],
    id: 'tax_certificate__contact_birthdate',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    tags: [],
  },
  contact_street: {
    fieldPath: 'contact_street',
    fieldReadPath: 'contact_street',
    name: 'contact_street',
    label: 'global.tax_certificates_contact_street_label',
    inputType: 'input',
    options: [],
    id: 'tax_certificate__contact_street',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    tags: [],
  },
  contact_street2: {
    fieldPath: 'contact_street2',
    fieldReadPath: 'contact_street2',
    name: 'contact_street2',
    label: 'global.tax_certificates_contact_street2_label',
    inputType: 'input',
    options: [],
    id: 'tax_certificate__contact_street2',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    tags: [],
  },
  contact_zip: {
    fieldPath: 'contact_zip',
    fieldReadPath: 'contact_zip',
    name: 'contact_zip',
    label: 'global.tax_certificates_contact_zip_label',
    inputType: 'input',
    options: [],
    id: 'tax_certificate__contact_zip',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    tags: [],
  },
  contact_city: {
    fieldPath: 'contact_city',
    fieldReadPath: 'contact_city',
    name: 'contact_city',
    label: 'global.tax_certificates_contact_city_label',
    inputType: 'input',
    options: [],
    id: 'tax_certificate__contact_city',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    tags: [],
  },
  contact_country: {
    fieldPath: 'contact_country',
    fieldReadPath: 'contact_country',
    name: 'contact_country',
    label: 'global.tax_certificates_contact_country_label',
    inputType: 'countries-selector',
    options: [
      {
        text: 'countries.placeholder',
        value: 'null',
      },
      {
        text: 'countries.ad',
        value: 'ad',
      },
      {
        text: 'countries.ae',
        value: 'ae',
      },
      {
        text: 'countries.af',
        value: 'af',
      },
      {
        text: 'countries.ag',
        value: 'ag',
      },
      {
        text: 'countries.ai',
        value: 'ai',
      },
      {
        text: 'countries.al',
        value: 'al',
      },
      {
        text: 'countries.am',
        value: 'am',
      },
      {
        text: 'countries.ao',
        value: 'ao',
      },
      {
        text: 'countries.aq',
        value: 'aq',
      },
      {
        text: 'countries.ar',
        value: 'ar',
      },
      {
        text: 'countries.as',
        value: 'as',
      },
      {
        text: 'countries.at',
        value: 'at',
      },
      {
        text: 'countries.au',
        value: 'au',
      },
      {
        text: 'countries.aw',
        value: 'aw',
      },
      {
        text: 'countries.ax',
        value: 'ax',
      },
      {
        text: 'countries.az',
        value: 'az',
      },
      {
        text: 'countries.ba',
        value: 'ba',
      },
      {
        text: 'countries.bb',
        value: 'bb',
      },
      {
        text: 'countries.bd',
        value: 'bd',
      },
      {
        text: 'countries.be',
        value: 'be',
      },
      {
        text: 'countries.bf',
        value: 'bf',
      },
      {
        text: 'countries.bg',
        value: 'bg',
      },
      {
        text: 'countries.bh',
        value: 'bh',
      },
      {
        text: 'countries.bi',
        value: 'bi',
      },
      {
        text: 'countries.bj',
        value: 'bj',
      },
      {
        text: 'countries.bl',
        value: 'bl',
      },
      {
        text: 'countries.bm',
        value: 'bm',
      },
      {
        text: 'countries.bn',
        value: 'bn',
      },
      {
        text: 'countries.bo',
        value: 'bo',
      },
      {
        text: 'countries.bq',
        value: 'bq',
      },
      {
        text: 'countries.br',
        value: 'br',
      },
      {
        text: 'countries.bs',
        value: 'bs',
      },
      {
        text: 'countries.bt',
        value: 'bt',
      },
      {
        text: 'countries.bv',
        value: 'bv',
      },
      {
        text: 'countries.bw',
        value: 'bw',
      },
      {
        text: 'countries.by',
        value: 'by',
      },
      {
        text: 'countries.bz',
        value: 'bz',
      },
      {
        text: 'countries.ca',
        value: 'ca',
      },
      {
        text: 'countries.cc',
        value: 'cc',
      },
      {
        text: 'countries.cd',
        value: 'cd',
      },
      {
        text: 'countries.cf',
        value: 'cf',
      },
      {
        text: 'countries.cg',
        value: 'cg',
      },
      {
        text: 'countries.ch',
        value: 'ch',
      },
      {
        text: 'countries.ci',
        value: 'ci',
      },
      {
        text: 'countries.ck',
        value: 'ck',
      },
      {
        text: 'countries.cl',
        value: 'cl',
      },
      {
        text: 'countries.cm',
        value: 'cm',
      },
      {
        text: 'countries.cn',
        value: 'cn',
      },
      {
        text: 'countries.co',
        value: 'co',
      },
      {
        text: 'countries.cr',
        value: 'cr',
      },
      {
        text: 'countries.cu',
        value: 'cu',
      },
      {
        text: 'countries.cv',
        value: 'cv',
      },
      {
        text: 'countries.cw',
        value: 'cw',
      },
      {
        text: 'countries.cx',
        value: 'cx',
      },
      {
        text: 'countries.cy',
        value: 'cy',
      },
      {
        text: 'countries.cz',
        value: 'cz',
      },
      {
        text: 'countries.de',
        value: 'de',
      },
      {
        text: 'countries.dj',
        value: 'dj',
      },
      {
        text: 'countries.dk',
        value: 'dk',
      },
      {
        text: 'countries.dm',
        value: 'dm',
      },
      {
        text: 'countries.do',
        value: 'do',
      },
      {
        text: 'countries.dz',
        value: 'dz',
      },
      {
        text: 'countries.ec',
        value: 'ec',
      },
      {
        text: 'countries.ee',
        value: 'ee',
      },
      {
        text: 'countries.eg',
        value: 'eg',
      },
      {
        text: 'countries.eh',
        value: 'eh',
      },
      {
        text: 'countries.er',
        value: 'er',
      },
      {
        text: 'countries.es',
        value: 'es',
      },
      {
        text: 'countries.et',
        value: 'et',
      },
      {
        text: 'countries.fi',
        value: 'fi',
      },
      {
        text: 'countries.fj',
        value: 'fj',
      },
      {
        text: 'countries.fk',
        value: 'fk',
      },
      {
        text: 'countries.fm',
        value: 'fm',
      },
      {
        text: 'countries.fo',
        value: 'fo',
      },
      {
        text: 'countries.fr',
        value: 'fr',
      },
      {
        text: 'countries.ga',
        value: 'ga',
      },
      {
        text: 'countries.gb',
        value: 'gb',
      },
      {
        text: 'countries.gd',
        value: 'gd',
      },
      {
        text: 'countries.ge',
        value: 'ge',
      },
      {
        text: 'countries.gf',
        value: 'gf',
      },
      {
        text: 'countries.gg',
        value: 'gg',
      },
      {
        text: 'countries.gh',
        value: 'gh',
      },
      {
        text: 'countries.gi',
        value: 'gi',
      },
      {
        text: 'countries.gl',
        value: 'gl',
      },
      {
        text: 'countries.gm',
        value: 'gm',
      },
      {
        text: 'countries.gn',
        value: 'gn',
      },
      {
        text: 'countries.gp',
        value: 'gp',
      },
      {
        text: 'countries.gq',
        value: 'gq',
      },
      {
        text: 'countries.gr',
        value: 'gr',
      },
      {
        text: 'countries.gs',
        value: 'gs',
      },
      {
        text: 'countries.gt',
        value: 'gt',
      },
      {
        text: 'countries.gu',
        value: 'gu',
      },
      {
        text: 'countries.gw',
        value: 'gw',
      },
      {
        text: 'countries.gy',
        value: 'gy',
      },
      {
        text: 'countries.hk',
        value: 'hk',
      },
      {
        text: 'countries.hm',
        value: 'hm',
      },
      {
        text: 'countries.hn',
        value: 'hn',
      },
      {
        text: 'countries.hr',
        value: 'hr',
      },
      {
        text: 'countries.ht',
        value: 'ht',
      },
      {
        text: 'countries.hu',
        value: 'hu',
      },
      {
        text: 'countries.id',
        value: 'id',
      },
      {
        text: 'countries.ie',
        value: 'ie',
      },
      {
        text: 'countries.il',
        value: 'il',
      },
      {
        text: 'countries.im',
        value: 'im',
      },
      {
        text: 'countries.in',
        value: 'in',
      },
      {
        text: 'countries.io',
        value: 'io',
      },
      {
        text: 'countries.iq',
        value: 'iq',
      },
      {
        text: 'countries.ir',
        value: 'ir',
      },
      {
        text: 'countries.is',
        value: 'is',
      },
      {
        text: 'countries.it',
        value: 'it',
      },
      {
        text: 'countries.je',
        value: 'je',
      },
      {
        text: 'countries.jm',
        value: 'jm',
      },
      {
        text: 'countries.jo',
        value: 'jo',
      },
      {
        text: 'countries.jp',
        value: 'jp',
      },
      {
        text: 'countries.ke',
        value: 'ke',
      },
      {
        text: 'countries.kg',
        value: 'kg',
      },
      {
        text: 'countries.kh',
        value: 'kh',
      },
      {
        text: 'countries.ki',
        value: 'ki',
      },
      {
        text: 'countries.km',
        value: 'km',
      },
      {
        text: 'countries.kn',
        value: 'kn',
      },
      {
        text: 'countries.kp',
        value: 'kp',
      },
      {
        text: 'countries.kr',
        value: 'kr',
      },
      {
        text: 'countries.kw',
        value: 'kw',
      },
      {
        text: 'countries.ky',
        value: 'ky',
      },
      {
        text: 'countries.kz',
        value: 'kz',
      },
      {
        text: 'countries.la',
        value: 'la',
      },
      {
        text: 'countries.lb',
        value: 'lb',
      },
      {
        text: 'countries.lc',
        value: 'lc',
      },
      {
        text: 'countries.li',
        value: 'li',
      },
      {
        text: 'countries.lk',
        value: 'lk',
      },
      {
        text: 'countries.lr',
        value: 'lr',
      },
      {
        text: 'countries.ls',
        value: 'ls',
      },
      {
        text: 'countries.lt',
        value: 'lt',
      },
      {
        text: 'countries.lu',
        value: 'lu',
      },
      {
        text: 'countries.lv',
        value: 'lv',
      },
      {
        text: 'countries.ly',
        value: 'ly',
      },
      {
        text: 'countries.ma',
        value: 'ma',
      },
      {
        text: 'countries.mc',
        value: 'mc',
      },
      {
        text: 'countries.md',
        value: 'md',
      },
      {
        text: 'countries.me',
        value: 'me',
      },
      {
        text: 'countries.mf',
        value: 'mf',
      },
      {
        text: 'countries.mg',
        value: 'mg',
      },
      {
        text: 'countries.mh',
        value: 'mh',
      },
      {
        text: 'countries.mk',
        value: 'mk',
      },
      {
        text: 'countries.ml',
        value: 'ml',
      },
      {
        text: 'countries.mm',
        value: 'mm',
      },
      {
        text: 'countries.mn',
        value: 'mn',
      },
      {
        text: 'countries.mo',
        value: 'mo',
      },
      {
        text: 'countries.mp',
        value: 'mp',
      },
      {
        text: 'countries.mq',
        value: 'mq',
      },
      {
        text: 'countries.mr',
        value: 'mr',
      },
      {
        text: 'countries.ms',
        value: 'ms',
      },
      {
        text: 'countries.mt',
        value: 'mt',
      },
      {
        text: 'countries.mu',
        value: 'mu',
      },
      {
        text: 'countries.mv',
        value: 'mv',
      },
      {
        text: 'countries.mw',
        value: 'mw',
      },
      {
        text: 'countries.mx',
        value: 'mx',
      },
      {
        text: 'countries.my',
        value: 'my',
      },
      {
        text: 'countries.mz',
        value: 'mz',
      },
      {
        text: 'countries.na',
        value: 'na',
      },
      {
        text: 'countries.nc',
        value: 'nc',
      },
      {
        text: 'countries.ne',
        value: 'ne',
      },
      {
        text: 'countries.nf',
        value: 'nf',
      },
      {
        text: 'countries.ng',
        value: 'ng',
      },
      {
        text: 'countries.ni',
        value: 'ni',
      },
      {
        text: 'countries.nl',
        value: 'nl',
      },
      {
        text: 'countries.no',
        value: 'no',
      },
      {
        text: 'countries.np',
        value: 'np',
      },
      {
        text: 'countries.nr',
        value: 'nr',
      },
      {
        text: 'countries.nu',
        value: 'nu',
      },
      {
        text: 'countries.nz',
        value: 'nz',
      },
      {
        text: 'countries.om',
        value: 'om',
      },
      {
        text: 'countries.pa',
        value: 'pa',
      },
      {
        text: 'countries.pe',
        value: 'pe',
      },
      {
        text: 'countries.pf',
        value: 'pf',
      },
      {
        text: 'countries.pg',
        value: 'pg',
      },
      {
        text: 'countries.ph',
        value: 'ph',
      },
      {
        text: 'countries.pk',
        value: 'pk',
      },
      {
        text: 'countries.pl',
        value: 'pl',
      },
      {
        text: 'countries.pm',
        value: 'pm',
      },
      {
        text: 'countries.pn',
        value: 'pn',
      },
      {
        text: 'countries.pr',
        value: 'pr',
      },
      {
        text: 'countries.ps',
        value: 'ps',
      },
      {
        text: 'countries.pt',
        value: 'pt',
      },
      {
        text: 'countries.pw',
        value: 'pw',
      },
      {
        text: 'countries.py',
        value: 'py',
      },
      {
        text: 'countries.qa',
        value: 'qa',
      },
      {
        text: 'countries.re',
        value: 're',
      },
      {
        text: 'countries.ro',
        value: 'ro',
      },
      {
        text: 'countries.rs',
        value: 'rs',
      },
      {
        text: 'countries.ru',
        value: 'ru',
      },
      {
        text: 'countries.rw',
        value: 'rw',
      },
      {
        text: 'countries.sa',
        value: 'sa',
      },
      {
        text: 'countries.sb',
        value: 'sb',
      },
      {
        text: 'countries.sc',
        value: 'sc',
      },
      {
        text: 'countries.sd',
        value: 'sd',
      },
      {
        text: 'countries.se',
        value: 'se',
      },
      {
        text: 'countries.sg',
        value: 'sg',
      },
      {
        text: 'countries.sh',
        value: 'sh',
      },
      {
        text: 'countries.si',
        value: 'si',
      },
      {
        text: 'countries.sj',
        value: 'sj',
      },
      {
        text: 'countries.sk',
        value: 'sk',
      },
      {
        text: 'countries.sl',
        value: 'sl',
      },
      {
        text: 'countries.sm',
        value: 'sm',
      },
      {
        text: 'countries.sn',
        value: 'sn',
      },
      {
        text: 'countries.so',
        value: 'so',
      },
      {
        text: 'countries.sr',
        value: 'sr',
      },
      {
        text: 'countries.ss',
        value: 'ss',
      },
      {
        text: 'countries.st',
        value: 'st',
      },
      {
        text: 'countries.sv',
        value: 'sv',
      },
      {
        text: 'countries.sx',
        value: 'sx',
      },
      {
        text: 'countries.sy',
        value: 'sy',
      },
      {
        text: 'countries.sz',
        value: 'sz',
      },
      {
        text: 'countries.tc',
        value: 'tc',
      },
      {
        text: 'countries.td',
        value: 'td',
      },
      {
        text: 'countries.tf',
        value: 'tf',
      },
      {
        text: 'countries.tg',
        value: 'tg',
      },
      {
        text: 'countries.th',
        value: 'th',
      },
      {
        text: 'countries.tj',
        value: 'tj',
      },
      {
        text: 'countries.tk',
        value: 'tk',
      },
      {
        text: 'countries.tl',
        value: 'tl',
      },
      {
        text: 'countries.tm',
        value: 'tm',
      },
      {
        text: 'countries.tn',
        value: 'tn',
      },
      {
        text: 'countries.to',
        value: 'to',
      },
      {
        text: 'countries.tr',
        value: 'tr',
      },
      {
        text: 'countries.tt',
        value: 'tt',
      },
      {
        text: 'countries.tv',
        value: 'tv',
      },
      {
        text: 'countries.tw',
        value: 'tw',
      },
      {
        text: 'countries.tz',
        value: 'tz',
      },
      {
        text: 'countries.ua',
        value: 'ua',
      },
      {
        text: 'countries.ug',
        value: 'ug',
      },
      {
        text: 'countries.um',
        value: 'um',
      },
      {
        text: 'countries.us',
        value: 'us',
      },
      {
        text: 'countries.uy',
        value: 'uy',
      },
      {
        text: 'countries.uz',
        value: 'uz',
      },
      {
        text: 'countries.va',
        value: 'va',
      },
      {
        text: 'countries.vc',
        value: 'vc',
      },
      {
        text: 'countries.ve',
        value: 've',
      },
      {
        text: 'countries.vg',
        value: 'vg',
      },
      {
        text: 'countries.vi',
        value: 'vi',
      },
      {
        text: 'countries.vn',
        value: 'vn',
      },
      {
        text: 'countries.vu',
        value: 'vu',
      },
      {
        text: 'countries.wf',
        value: 'wf',
      },
      {
        text: 'countries.ws',
        value: 'ws',
      },
      {
        text: 'countries.xk',
        value: 'xk',
      },
      {
        text: 'countries.ye',
        value: 'ye',
      },
      {
        text: 'countries.yt',
        value: 'yt',
      },
      {
        text: 'countries.za',
        value: 'za',
      },
      {
        text: 'countries.zm',
        value: 'zm',
      },
      {
        text: 'countries.zw',
        value: 'zw',
      },
      {
        text: 'countries.other',
        value: 'other',
      },
    ],
    id: 'tax_certificate__contact_country',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    tags: [],
  },
};

export const taxCertificatePeriodFields = {
  id: {
    fieldPath: 'id',
    fieldReadPath: 'id',
    name: 'id',
  },
  center_id: {
    fieldPath: 'center_id',
    fieldReadPath: 'center_id',
    name: 'center_id',
  },
  tax_certificate_id: {
    fieldPath: 'tax_certificate_id',
    fieldReadPath: 'tax_certificate_id',
    name: 'tax_certificate_id',
  },
  enrollment_id: {
    fieldPath: 'enrollment_id',
    fieldReadPath: 'enrollment_id',
    name: 'enrollment_id',
    label: 'global.tax_certificates_enrollment_id_label',
    inputType: 'input',
    options: [],
    id: 'tax_certificate__enrollment_id',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    tags: [],
    selectLabel: 'code_activity',
    selectValue: 'id',
    selectEntity: 'enrollment',
    selectClearable: false,
    selectMultiple: false,
    withTableSearch: false,
    withNew: false,
    filters: [
      {
        filterField: 'type',
        modelField: null,
        value: ['individual'],
      },
      {
        filterField: 'status',
        modelField: null,
        value: ['active'],
      },
    ],
  },
  start_date: {
    fieldPath: 'start_date',
    fieldReadPath: 'start_date',
    name: 'start_date',
    label: 'global.tax_certificates_start_date_label',
    inputType: 'datepicker',
    options: [],
    id: 'tax_certificate__start_date',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    tags: [],
  },
  end_date: {
    fieldPath: 'end_date',
    fieldReadPath: 'end_date',
    name: 'end_date',
    label: 'global.tax_certificates_end_date_label',
    inputType: 'datepicker',
    options: [],
    id: 'tax_certificate__end_date',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    tags: [],
  },
  num_days: {
    fieldPath: 'num_days',
    fieldReadPath: 'num_days',
    name: 'num_days',
    label: 'global.tax_certificates_num_days_label',
    inputType: 'input',
    options: [],
    id: 'tax_certificate__num_days',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    tags: [],
  },
  price_per_day: {
    fieldPath: 'price_per_day',
    fieldReadPath: 'price_per_day',
    name: 'price_per_day',
    label: 'global.tax_certificates_price_per_day_label',
    inputType: 'input-group',
    appendIcon: 'euro-sign',
    fieldAttributes: {
      type: 'number',
      step: '.01',
    },
    id: 'tax_certificate__price_per_day',
    veeValidation: true,
    rules: ['nullable'],
    warningRules: [],
    tags: [],
  },
  paid_amount: {
    fieldPath: 'paid_amount',
    fieldReadPath: 'paid_amount',
    name: 'paid_amount',
    label: 'global.tax_certificates_paid_amount_label',
    inputType: 'input-group',
    appendIcon: 'euro-sign',
    fieldAttributes: {
      type: 'number',
      step: '.01',
    },
    id: 'tax_certificate__paid_amount',
    veeValidation: true,
    rules: ['required'],
    warningRules: [],
    tags: [],
  },
};
